import React, { useCallback, useState } from "react";
import { useParams } from "react-router-dom";
import { MemberRegistrationEmailContainer } from "../../features/member_registration";
import useMemberRegistrationStore, {
  sendMemberRegistrationEmail,
} from "../../features/member_registration/redux/store";
import { HeaderTemplate } from "../../template";
import { Base } from "../../template/style";
import { Footer } from "../../ui/footer/Footer";
import { useNavigate } from "../../../lib/hooks/useNavigate";
import { useLocation } from "react-router-dom";

export const MemberRegistrationEmail: React.FC = () => {
  const { tenant_code } = useParams();
  const navigation = useNavigate();
  const enabled = useMemberRegistrationStore((state) => state.enabled);
  // utm tag
  const _location = useLocation();
  const utm_source = _location.state?.utm_source ?? "";
  const utm_medium = _location.state?.utm_medium ?? "";
  const utm_campaign = _location.state?.utm_campaign ?? "";
  const utm_term = _location.state?.utm_term ?? "";
  const utm_content = _location.state?.utm_content ?? "";

  const onComplete = useCallback(() => {
    navigation("/mail_send");
  }, []);

  return (
    <Base>
      <HeaderTemplate>
        <MemberRegistrationEmailContainer page={`register`} />
      </HeaderTemplate>
      <Footer
        buttonText="送信"
        onClickButton={() => {
          sendMemberRegistrationEmail(
            tenant_code ?? "",
            "register",
            utm_source,
            utm_medium,
            utm_campaign,
            utm_term,
            utm_content,
          )
            .then(onComplete)
            .catch((e) => {
              /* nothing to do */
              console.log("error", e);
            });
        }}
        buttonDisabled={!enabled}
      />
    </Base>
  );
};
